import React from 'react';
import PropTypes from 'prop-types';

const ThumbsDownIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Thumbs down"
  >
    <path d="M14.5 3H18C19.105 3 20 3.895 20 5V13C20 14.105 19.105 15 18 15H14.5V3Z" stroke="currentColor" strokeWidth="1.8" />
    <path d="M14.5 14L11 21C10.172 21 9.5 20.328 9.5 19.5V15.5H5.5C4.12 15.5 3.169 14.118 3.662 12.83L5.96 6.83C6.256 6.056 6.999 5.545 7.827 5.545H14.5V14Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
  </svg>
);

ThumbsDownIcon.propTypes = {
  className: PropTypes.string
};

ThumbsDownIcon.defaultProps = {
  className: ''
};

export default ThumbsDownIcon;
